import { render, staticRenderFns } from "./TablaGestionColegios.vue?vue&type=template&id=24bf537e&scoped=true&"
import script from "./TablaGestionColegios.vue?vue&type=script&lang=js&"
export * from "./TablaGestionColegios.vue?vue&type=script&lang=js&"
import style0 from "./TablaGestionColegios.vue?vue&type=style&index=0&id=24bf537e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf537e",
  null
  
)

export default component.exports